<template>
  <div class="carousel-container">
    <!-- 桌面端水平轮播 -->
    <el-carousel ref="outCarousel" v-if="isDesktop" type="card" height="60vh" :autoplay="swiprAutoPlay" trigger="click"
      direction="horizontal" v-model="activeParentIndex" @change="outSwiperChange">
      <el-carousel-item v-for="(item, parentIndex) in carouselSlides" :key="parentIndex">
        <h3 class="medium">{{ item.title }}</h3>
        <p>{{ item.description }}</p>
        <div class="img-box">
          <!-- 内部图片轮播：修复激活判断，绑定父轮播当前索引 -->
          <el-carousel ref="inCarousel" height="370px" :autoplay="activeParentIndex === parentIndex"
            indicator-position="none" arrow="never" @change="inSwiperChange" :interval="4000">
            <el-carousel-item v-for="(imgUrl, imgIndex) in item.imageArr" :key="imgIndex">
              <img :src="imgUrl" alt="轮播图片" />
            </el-carousel-item>
          </el-carousel>
          <div v-if="item.url" class="btn" @click="navToFun(item.url)">
            <i class="el-icon-thumb"></i>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>

    <!-- 移动端垂直轮播 -->
    <el-carousel v-else height="50vh" type="card" :autoplay="false" trigger="click" direction="vertical">
      <el-carousel-item v-for="item in carouselSlides" :key="item.id">
        <h3 class="medium">{{ item.title }}</h3>
        <p>{{ item.description }}</p>
        <div class="img-box">
          <div v-if="item.url" class="btn" @click="navToFun(item.url)"> <!-- 修复：传递url参数，统一逻辑 -->
            <i class="el-icon-thumb"></i>
          </div>
          <!-- 移动端取第一张图片作为展示 -->
          <img :src="item.imageArr[0]" alt="轮播图片" />
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: "NestedCarousel",
  data() {
    return {
      // 父轮播当前激活索引（响应式变量，用于控制内部轮播自动播放）
      activeParentIndex: 0,
      // 父轮播自动播放开关（提取为全局响应式变量，移除数据内部冗余）
      swiprAutoPlay: false,
      carouselSlides: [
        {
          id: 1,
          title: "春芽共融：艺起生长的N种可能",
          description:
            "在春意盎然、万物莲勃生长的美好时节，由澳门扶康会与澳门培华中学共同策展，天汇星艺术空间为广大艺术爱好者们呈上“春芽共融：艺起生长的N种可能”主题艺术双展，致力让横琴的市民和各界朋友感受澳门孩子的纯真创意。",
          imageArr: [
            require("../assets/images/artimgs/art01.png"),
            require("../assets/images/artimgs/art02.png"),
            require("../assets/images/artimgs/art03.png"),
            require("../assets/images/artimgs/art04.png"),
          ],
          url: ""
        },
        {
          id: 2,
          title: "“寻境数语”&“多元回响”",
          description: "为了庆祝澳门回归25周年加强横琴与澳门的文化互通和联系，“寻境数语”澳门科技艺术展与“多元回响”琴澳青年艺术联展，打造数字艺术的全新体验空间来展示琴澳青年艺术家作品。",
          imageArr: [
            require("../assets/images/artimgs/art2_1.png"),
            require("../assets/images/artimgs/art2_2.png"),
            require("../assets/images/artimgs/art2_3.png"),
            require("../assets/images/artimgs/art2_4.png"),
          ],
          url: "https://mp.weixin.qq.com/s/SlAOB8kn7wWLgMrxVlZWWw"
        },
        {
          id: 3,
          title: "曈星联盟之“壹魅力”杯 平衡车赛",
          description: "本次比赛是珠海首个将平衡车竞速与影视综合资源结合的赛事，亮点包括专业赛道设计、亲子互动环节以及“瞳星联盟”的明星选手表演赛。活动吸引了近500名参赛者及观众，在推广平衡车运动和提升横琴文旅形象方面成效显著。",
          imageArr: [
            require("../assets/images/artimgs/art3_1.png"),
            require("../assets/images/artimgs/art3_2.png"),
            require("../assets/images/artimgs/art3_3.png"),
          ],
          url: "https://mp.weixin.qq.com/s/JaS23DpjDNHTqwoImhGAkQ"
        },
        {
          id: 4,
          title: "「生生不息 边界‧探索」艺术作品展巡回展览",
          description: "由澳门自闭症协会主办的「生生不息 边界‧探索」艺术作品展巡回展览，2025年落地于天汇星艺术空间，期望以大湾区联展形式，打破公众对自闭症的认知边界，推动建立包容共生的社会环境。",
          imageArr: [
            require("../assets/images/artimgs/art4_1.png"),
            require("../assets/images/artimgs/art4_2.png"),
            require("../assets/images/artimgs/art4_3.png"),
            require("../assets/images/artimgs/art4_4.png"),
          ],
          url: ""
        },
        {
          id: 5,
          title: "“诗形物影”琴澳新篇 & 流转之间-多媒体水墨舞蹈剧场展演",
          description: "2025年艺术双展以科技赋能传统美学，融合诗意与水墨舞蹈。在“时、空、念”的流转中构筑流动剧场。邀您步入这场跨越边界、对话东西的感官奇遇，在流动的艺术中，探寻生命的无限诗意。",
          imageArr: [
            require("../assets/images/artimgs/art5_1.png"),
            require("../assets/images/artimgs/art5_2.png"),
            require("../assets/images/artimgs/art5_3.png"),
            require("../assets/images/artimgs/art5_4.png"),
          ],
          url: ""
        },
        {
          id: 6,
          title: "世界反法西斯战争胜利80周年粤澳姐妹学校合作区文艺汇演",
          description: "由澳门教育及青年发展局与横琴民生事务局联合主办的湾区中学生文艺汇演，在2500平方米户外广场成功举办。晚会汇集两地12所学校350余名师生，以多种表演形式，表达对抗战英烈的缅怀以及对中华文化的创新诠释。",
          imageArr: [
            require("../assets/images/artimgs/art6_1.png"),
            require("../assets/images/artimgs/art6_2.png"),
            require("../assets/images/artimgs/art6_3.png"),
          ],
          url: ""
        },
        {
          id: 7,
          title: "城市复调：琴澳之间的景观社会 — “洞”单元",
          description: "三位澳门艺术家以水泥、像素与玻璃为媒体，在固化、流动与透明间重构城市灵魂。独立空间交织成互相对话的“洞见形态”，构成了一场城市复调的感官奇遇与思想对话。",
          imageArr: [
            require("../assets/images/artimgs/art7_1.png"),
            require("../assets/images/artimgs/art7_2.png"),
            require("../assets/images/artimgs/art7_3.png"),
            require("../assets/images/artimgs/art7_4.png"),
          ],
          url: ""
        },
        {
          id: 8,
          title: "Championing all Voices! 共融艺术节",
          description: "本次活动致力借着艺术推动社会对残障群体的关注与理解，为边缘群体提供一个释放潜能、表达自我的舞台。令更多公共空间与文化平台见证伤健共融的美好时刻，实现真正的社会共融。",
          imageArr: [
            require("../assets/images/artimgs/art8_1.png"),
            require("../assets/images/artimgs/art8_2.png"),
            require("../assets/images/artimgs/art8_3.png"),
            require("../assets/images/artimgs/art8_4.png"),
          ],
          url: ""
        },
        {
          id: 9,
          title: "《ROLLOUT卫星点对点舞蹈影像展》",
          description: "ROLLOUT登陆横琴天汇星，开启琴澳“点对点”艺术对话。展览以肢体解构城市记忆，涵盖快拍挑战赛与八载经典回顾。27部佳作在光影流转间，呈现一场重塑时空的感官风暴。",
          imageArr: [
            require("../assets/images/artimgs/art9_1.png"),
            require("../assets/images/artimgs/art9_2.png"),
          ],
          url: ""
        },
        {
          id: 10,
          title: "儿童音乐剧《穿越时空的玛利亚》",
          description: "获横琴民生事务局支持指导、澳门售票网提供票务支持，琴澳首个户外儿童音乐剧于天汇星影视综合城户外广场成功落地。",
          imageArr: [
            require("../assets/images/artimgs/art10_1.png"),
            require("../assets/images/artimgs/art10_2.png"),
            require("../assets/images/artimgs/art10_3.png"),
            require("../assets/images/artimgs/art10_4.png"),
          ],
          url: ""
        },
      ],
      isDesktop: window.innerWidth >= 768,
    };
  },
  mounted() {
    // 添加窗口大小变化监听器
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    // 移除监听器防止内存泄漏
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    navToFun(url) {
      // 增加url有效性判断，避免无效跳转
      if (url) {
        window.open(url, '_blank');
      }
    },
    handleResize() {
      // 更新设备类型，增加防抖（避免窗口频繁resize触发多次更新）
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.isDesktop = window.innerWidth >= 768;
      }, 200);
    },
    outSwiperChange(idx) {
      console.log('outIdx', idx);
      this.activeParentIndex = idx
    },
    inSwiperChange(idx) {
      if (idx == 0) {
        this.$refs.outCarousel.next();
      }
    }
  }
};  
</script>

<style scoped lang="scss">
.carousel-container {
  width: 100%;
  max-width: 1350px;
  margin: 0 auto;
  box-shadow: rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgba(29, 37, 150, 0.15) 0px 8px 24px -4px;

}

.el-carousel__item {
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.el-carousel__item p,
.el-carousel__item h3 {
  width: 95%;
}

.el-carousel__item p {
  text-align: justify;
}

.img-box {
  position: relative;
  width: 100%;
  height: 100%;
}

.img-box img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 10px;
}

.img-box .btn {
  position: absolute;
  right: 1rem;
  bottom: 2rem;
  background-color: white;
  box-shadow: 5px 5px 5px black;
  padding: 0.8rem 1rem;
  /* 增加内边距，提升点击体验 */
  border-radius: 8px;
  /* 增加圆角，视觉更柔和 */
  cursor: pointer;
  z-index: 1000;
  /* 增加鼠标指针样式，提示可点击 */

  &:hover {
    box-shadow: none;
    background-color: #e1bd85;
    transition: all 0.3s ease;
    /* 增加过渡动画，提升交互体验 */

    i {
      color: white;
    }
  }
}

/* 基础字体大小 */
:root {
  font-size: 16px;
}

/* 平板设备 */
@media (max-width: 992px) {
  :root {
    font-size: 14px;
  }

  .el-carousel__item h3.medium {
    font-size: 1.5rem;
    line-height: 2.5rem;
  }

  .el-carousel__item p {
    font-size: 1rem;
  }
}

/* 移动设备 */
@media (max-width: 768px) {
  :root {
    font-size: 12px;
  }

  .carousel-container {
    height: auto;
  }

  .el-carousel__item {
    height: auto;
    width: 100%;
    padding: 0.8rem;
    /* 调整移动端内边距，适配小屏幕 */
  }

  .el-carousel__item h3.medium {
    font-size: 1.2rem;
    line-height: 2rem;
  }

  .el-carousel__item p {
    font-size: 0.9rem;
    margin: 0.5rem 0;
    /* 增加上下外边距，提升可读性 */
  }

  .img-box .btn {
    right: 0.8rem;
    bottom: 1.5rem;
    padding: 0.6rem 0.8rem;
    /* 适配移动端，缩小按钮尺寸 */
  }
}

.el-carousel__item h3.medium {
  color: #ae9281;
  font-weight: bold;
  margin: 0.5rem 0;
  /* 增加上下外边距，优化排版 */
}

.el-carousel__item:nth-child(2n) {
  background-color: white;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: white;
}
</style>